import $ from "dabbyjs/src/core/dabby/dabby.js";
import commentary from "../review/javascript/commentary.js";
import insert from "../review/javascript/insert-statements.js";
import "../../swgfl/report/javascript/report.js";
import tableRowLink from "../../swgfl/javascript/table-row-link.js";

export default () => {
	commentary($(".form__control-radio--review .form__control-radio-input"), $(".review__questions-commentary"));
	insert($(".question__statements-content-item"));
	tableRowLink($(".reports__table"));
};
